<template>
  <ModalContainer queryParam="signosVitales" ref="modalSignos" size="xl">
    <b-card>
      
      <b-row>
        <div class= "col-md-4 d-grid" style="grid-template-columns: repeat(2, 1fr);">

          <InformacionCita 
            :tokenCita="tokenCita"
          />

          <br>

          <InfoSignosVitales
            v-if="idPaciente"
            :idPaciente="idPaciente"
            :idCitaActual="idCita"
            noCopyBytton
            noCitaActual
          />
        </div>

        <div class="col-md-8 d-grid" style="grid-template-columns: repeat(2, 1fr);">

          
          <b-card border-variant="primary" class="mb-3">

            <b-alert show :variant="messageAlert.variant" class="p-2">
              <div class="text-center">{{ messageAlert.text }}</div>
            </b-alert>

            <h4 class="text-center my-2">Agregar signos vitales</h4>
            <hr>
            <b-row class="my-2 mt-3">

              <b-col class="col-6">
                <b-row class="d-flex align-items-center">
                  <label 
                    for="peso"
                    class="col-4"
                  >Peso (Kg):</label>

                  <validation-provider
                    #default="{ errors }"
                    name="Peso"
                    rules="required"
                  >
                    <b-form-input
                      v-model="peso"
                      :state="errors.length > 0 ? false : null"
                      type="text"
                      id="peso"
                      @keypress="(e) => numberDecimal(e, 3, 2)"
                      @blur="onBlurInput"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-row>
              </b-col>


              <b-col class="col-6">
                <b-row class="d-flex align-items-center">
                  <label for="talla" class="col-4">Talla (cm):</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Talla"
                    rules="required"
                  >
                    <b-form-input
                      v-model="talla"
                      :state="errors.length > 0 ? false : null"
                      type="text"
                      id="talla"
                      maxlength="3"
                      @keypress="onlyNumbers"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-row>
              </b-col>

              <b-col class="col-6 my-1">
                <b-row class="d-flex align-items-center">
                  <label for="imc" class="col-4">IMC:</label>
                  <validation-provider
                    #default="{ errors }"
                    name="IMC"
                    rules="required"
                  >
                    <b-form-input
                      v-model="imc"
                      :state="errors.length > 0 ? false : null"
                      type="number"
                      id="imc"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-row>
              </b-col>

              <b-col class="col-6 my-1">
                <b-row class="d-flex align-items-center">
                  <label for="temperatura" class="col-4">Temperatura (Cº):</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Temperatura"
                    rules="required"
                  >
                    <b-form-input
                      v-model="temperatura"
                      :state="errors.length > 0 ? false : null" 
                      type="text"
                      id="temperatura"
                      @keypress="e => numberDecimal(e, 2, 2)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-row>
              </b-col>
            </b-row>

            <hr>

            <b-row class="my-2">

              <b-col class="col-6">
                <b-row class="d-flex align-items-center">
                  <label for="freqRespiratoria" class="col-5">
                    Frec. Respiratoria (resp/min):
                  </label>
                
                  <b-form-input
                    class="col-6"
                    v-model="freqRespiratoria"
                    type="text"
                    maxlength="3"
                    @keypress="onlyNumbers"
                    id="freqRespiratoria"
                  />
                    
                </b-row>
              </b-col>


              <b-col class="col-6">
                <b-row class="d-flex align-items-center">
                  <label for="satOxigeno" class="col-5">
                    Sat. de Oxígeno (%):
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Saturacion"
                    rules="required"
                  >
                    <b-form-input
                      v-model="satOxigeno"
                      :state="errors.length > 0 ? false : null"
                      type="text"
                      id="satOxigeno"
                      @keypress="onlyNumbers"
                      maxlength="3"
                      
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-row>
              </b-col>

              <b-col class="col-6 my-1">
                <b-row class="d-flex align-items-center">
                  <label for="tensionArterial" class="col-5">
                    Tensión Arterial (mm Hg):
                  </label>
                  
                  <b-input-group class="col pl-0">
                    <b-form-input
                      v-model="tensionArterial.sistolica"
                      placeholder="Sistolica"
                      type="text"
                      maxlength="3"
                      @keypress="onlyNumbers"
                    />
                
                    <b-form-input
                      v-model="tensionArterial.diastolica"
                      placeholder="Diastolica"
                      type="text"
                      maxlength="3"
                      @keypress="onlyNumbers"
                    />
                  </b-input-group>
                </b-row>
              </b-col>

              <b-col class="col-6 my-1">
                <b-row class="d-flex align-items-center">
                  <label for="pulso" class="col-5">
                    Pulso (latidos/min):
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Pulso"
                    rules="required"
                  >
                    <b-form-input
                      v-model="pulso"
                      :state="errors.length > 0 ? false : null"
                      type="text"
                      maxlength="3"
                      @keypress="onlyNumbers"
                      id="pulso"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-row>
              </b-col>
            </b-row>

            <hr>

            <b-row class="my-2">
              <h5 class="col-12 my-1">Otros Signos Vitales</h5>
              <b-col class="col-6">
                <b-row>
                  <label for="perimetroCefalico" class="col-5">
                    Perímetro Cefálico (cm):
                  </label>
                  <validation-provider
                    class="col-4"
                    #default="{ errors }"
                    name="PerimetroCefalico"
                  >
                    <b-form-input
                      v-model="perimetroCefalico"
                      :state="errors.length > 0 ? false : null"
                      type="text"
                      id="perimetroCefalico"
                      maxlength="3"
                      
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-row>
              </b-col>


              <b-col class="col-6">
                <b-row>
                  <label for="perimetroAbdominal" class="col-5">
                    Perímetro Abdominal (cm):
                  </label>
                  <validation-provider
                    class="col-4"
                    #default="{ errors }"
                    name="PerimetroAbdominal"
                  >
                    <b-form-input
                      v-model="perimetroAbdominal"
                      :state="errors.length > 0 ? false : null"
                      type="text"
                      id="perimetroAbdominal"
                      maxlength="3"
                      
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-row>
              </b-col>
            </b-row>


            <b-row class="my-2 mt-3 d-flex justify-content-end">

              <b-button
                variant="primary"
                type="submit"
                @click.prevent="formSubmittedUpdateSignosVital"
                class="mr-1"
              >
                Guardar
              </b-button>
            </b-row>

          </b-card>
        </div>
      </b-row>
    </b-card>
  </ModalContainer>
</template>
  
<script>
import { ValidationProvider } from 'vee-validate'

import { required, email } from '@validations'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Swal from 'sweetalert2';

import { numberDecimal, onlyNumbers } from "@/shared/helpers";
import { ModalContainer } from '@/shared/components';

import { InformacionCita, InfoSignosVitales } from "@/views/atencionCita/components";
import { signosVitalesService } from '@/views/signosVitales/services';
  
export default {

  name:"SaveSignosVitales",

  components: {
    ValidationProvider,

    ModalContainer,
    InformacionCita,
    InfoSignosVitales
  },

  data() {
    return {

      idPaciente:null,
      tokenCita: null,

      peso:null,
      talla:null,
      imc:null,
      temperatura:null,
      freqRespiratoria:null,
      satOxigeno:null,

      tensionArterial:{
        sistolica:null,
        diastolica:null
      },

      pulso:null,

      perimetroCefalico:0,
      perimetroAbdominal:0,


      mensajes: {
        freqRespiratoria : null,
        imc:null,
        temperatura:null,
        satOxigeno:null,
        pulso:null,
        tensionArterial:null
      },

      idCita:null,
      name: '',
      required,
      email,
      
      messageAlert:{
        text: null,
        variant: null
      },
      
      erros:[],

      onlyNumbers,
      numberDecimal,

      idRegistroSignos:null
    }
  },


  async created() {
    await this.loadDataCita();
    this.setToken();
    this.calcularIMC();
  },

  

  methods: {


    onBlurInput() {
      console.log('validar inputs');
    },
    
    alertaTension(sistolica, diastolica, edad) {
      if (sistolica && diastolica) {

        const rangosTension = [
          { minEdad: 0,  maxEdad: 0,        minSistolica: 55,  maxSistolica: 100, minDiastolica: 35, maxDiastolica: 65 },
          { minEdad: 1,  maxEdad: 3,        minSistolica: 90,  maxSistolica: 105, minDiastolica: 55, maxDiastolica: 70 },
          { minEdad: 6,  maxEdad: 12,       minSistolica: 100, maxSistolica: 120, minDiastolica: 60, maxDiastolica: 75 },
          { minEdad: 13, maxEdad: Infinity, minSistolica: 110, maxSistolica: 135, minDiastolica: 65, maxDiastolica: 85 }
        ];

        // Encontrar el rango de tensión correspondiente
        const rango = rangosTension.find(r => edad >= r.minEdad && edad <= r.maxEdad);

        const dentroDelRango = sistolica >= rango.minSistolica && sistolica <= rango.maxSistolica &&
                              diastolica >= rango.minDiastolica && diastolica <= rango.maxDiastolica;

        const mensaje = dentroDelRango 
          ? "tension arterial dentro del rango" 
          : "Tension arterial fuera del rango de normalidad";
        this.mensajes.tensionArterial = !dentroDelRango ?  "Tension arterial" : null
      }
    },


    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('citamedica_ver_signosvital') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },


    async formSubmittedUpdateSignosVital() {
      if (this.talla && this.talla.length === 1 || this.peso && this.peso.length === 1 
        || this.temperatura && this.temperatura.length === 1 || this.freqRespiratoria && this.freqRespiratoria.length === 1
        || this.satOxigeno && this.satOxigeno.length === 1 || this.pulso && this.pulso.length === 1 || this.tensionArterial && this.tensionArterial.sistolica.length === 1
        || this.tensionArterial && this.tensionArterial.diastolica.length === 1) {

        this.$swal({
          title: 'Error',
          text: 'Un dato que ingreso no esta bien llenado',
          icon: 'error',
          confirmButtonColor: '#089599',
        }); return 
      }

      let data_mensajes = ''          
      let mensajesFiltrados = Object.entries(this.mensajes)
        .filter(([clave, valor]) => valor != null && valor !== '');

      if (mensajesFiltrados.length === 0) {
        // Todos los valores son nulos o vacíos
        data_mensajes = `<h4 style="color: green;">Signos dentro del rango de normalidad</h4>`;
      } else {
        // Hay valores fuera de rango
        let contenido = mensajesFiltrados
          .map(([clave, valor]) => `<li><strong><span style="color: red;">${valor}</span></strong></li>`)
          .join('');

        data_mensajes = `<h4>Los siguientes campos están fuera del rango de normalidad:</h4><br><ul>${contenido}</ul>`;
      }

      const result = await this.$swal({
        title: 'Alertas',
        html: data_mensajes,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#089599',
        cancelButtonColor: '#d33'
      });

      if (!result.isConfirmed) return;
      

      try {
        let timerInterval;
        Swal.fire({
          title: "Guardando Signos",
          html: 'Procesando... <b></b>',
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
            timerInterval = setInterval(() => {
              const timer = Swal.getTimerLeft();
              if (timer) {
                Swal.getContent().querySelector("b").textContent = `${timer}`;
              }
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          }
        });

        const idSignosVital = await this.onSaveSignosVitales();
        Swal.close();

        if (!idSignosVital) {
          
          await this.$swal({
            title: 'Error',
            text: 'Error al guardar Signos vitales',
            icon: 'error',
            confirmButtonColor: '#089599',
          });

          return;
        }

        await this.$swal({
          title: 'Info',
          text: 'Se creó los Signos Vitales',
          icon: 'success',
          confirmButtonColor: '#089599',
        });

        await this.$refs.modalSignos.closeModal()
        this.$router.go(0);

      } catch (err) {
        this.$swal({
          title: 'Error',
          text: 'Error en crear Signos vitales: ' + err,
          icon: 'error',
          confirmButtonColor: '#089599',
        });
      }

    },


    validationFormDocu() {
      return new Promise((resolve, reject) => {
        this.$refs.docuRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            this.$swal({
              title: 'Campos vacíos',
              text: 'Llenar todos los campos',
              icon: 'error',
              confirmButtonText: 'Entendido'
            })
            reject()
          }
        })
      })
    },


    calcularIMC() {
      if (this.talla && this.peso || this.peso && this.talla) {  // Asegura que ambos valores estén presentes
        const imcRaw = (parseFloat(this.peso) / (parseFloat(this.talla) * parseFloat(this.talla))) * 10000;
        this.imc = parseFloat(imcRaw.toFixed(2));
      }
    },
    
  

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    clearFormSignos() {
      this.idRegistroSignos = null;

      this.peso = null;
      this.talla = null;
      this.imc = null;
      this.tensionArterial.sistolica = null;
      this.tensionArterial.diastolica = null;
      this.pulso = null;
      this.freqRespiratoria = null;
      this.temperatura = null;
      this.satOxigeno = null;

      this.perimetroCefalico = 0;
      this.perimetroAbdominal = 0;

      this.errors = [];
      this.mensajes = {
        text    : null,
        variant : null
      };
    },


    async loadDataCita(){

      this.clearFormSignos();
      this.tokenCita = this.$route.query.signosVitales;
      if(!this.tokenCita) return;
      
      const responseCita = await this.fetchGetCita(this.tokenCita);

      const responseSignos = await signosVitalesService.getByCita(this.tokenCita);
      if (responseCita) {
        const dataCita = responseCita;
        this.edadPaciente = this.calcularEdad(dataCita.paciente.persona.fechaNacimiento);

        this.idPaciente = dataCita.paciente.id;
        this.idCita = dataCita.id;
      }


      if(responseSignos){

        this.idRegistroSignos = responseSignos.id

        this.messageAlert = {
          text    : 'Se encontro informacion registrada',
          variant : 'success'
        }

        this.peso  = responseSignos.peso;
        this.talla = responseSignos.talla;
        this.imc   = responseSignos.imc;
        this.tensionArterial.sistolica = responseSignos.tensionArterialSistolica;
        this.tensionArterial.diastolica = responseSignos.tensionArterialDiastolica;
        this.pulso = responseSignos.pulso;
        this.freqRespiratoria = responseSignos.freqRespiratoria;
        this.temperatura      = responseSignos.temperatura;
        this.satOxigeno       = responseSignos.satOxigeno;

        this.perimetroCefalico = responseSignos.perimetroCefalico;
        this.perimetroAbdominal = responseSignos.perimetroAbdominal;

        return;
      }

      this.messageAlert = {
        text    : 'No se encontro informacion registrada',
        variant : 'info'
      }
    },



    async fetchGetCita(tokenCita) {
      const query = `
        query qrgetTokenCita($token: String!){
          getTokenCita(tokenCita: $token) {
            cita {
              id
              horaCita
              fechaCita
              estado
              paciente{
                id
                persona {
                    primerNombre
                    primerApellido
                    identificacion
                    fechaNacimiento
                  }
                }
              doctor {
                id
                idPersona {
                  primerNombre
                  primerApellido
                  identificacion
                }
                especialidad {
                  descripcion
                }
              }
            }
            status
            message
          }
        }
      `;
      
      const variables = {
        token: tokenCita,
      };
      
      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.status !== 200) return null;

        const response2 = response.data.data.getTokenCita;
        if (response2.status !== 'success') return null;

        const data = response2.cita;
        return data;
        
      } catch (err) {
        console.log('Error crear Signos Vitales process:', err);
        return null;
      }
    },
    
    calcularEdad(fechaNacimiento) {
    
      const fechaNacimientoDate = new Date(fechaNacimiento);  
      const hoy = new Date();
      let edad = hoy.getFullYear() - fechaNacimientoDate.getFullYear();
      const mesDiferencia = hoy.getMonth() - fechaNacimientoDate.getMonth();
      if (mesDiferencia < 0 || (mesDiferencia === 0 && hoy.getDate() < fechaNacimientoDate.getDate())) {
        edad--;
      }
      
      return edad;
    },


    async onSaveSignosVitales() {

      const dataSignos = {
        idRegistroSignos         : this.idRegistroSignos,
        temperatura              : parseFloat(this.temperatura),
        peso                     : parseFloat(this.peso),
        talla                    : parseFloat(this.talla),
        imc                      : this.imc,
        pulso                    : parseFloat(this.pulso),
        freqRespiratoria         : parseFloat(this.freqRespiratoria),
        satOxigeno               : parseFloat(this.satOxigeno),
        perimetroCefalico        : parseFloat(this.perimetroCefalico),
        perimetroAbdominal       : parseFloat(this.perimetroAbdominal),
        tensionArterialSistolica : parseInt(this.tensionArterial.sistolica),
        tensionArterialDiastolica: parseInt(this.tensionArterial.diastolica),
      }
    
      const saveSignos = await signosVitalesService.saveRegister(this.tokenCita, dataSignos)

      return !!saveSignos
    },
  },


  watch: {
    pulso(newVal) {
      if (newVal) {

        // datos del archivo
        const rangosEdad = [
          { minEdad: 0,  maxEdad: 0,        minPulso: 90, maxPulso: 170 },
          { minEdad: 1,  maxEdad: 3,        minPulso: 80, maxPulso: 150 },
          { minEdad: 4,  maxEdad: 6,        minPulso: 80, maxPulso: 140 },
          { minEdad: 7,  maxEdad: 12,       minPulso: 60, maxPulso: 100 },
          { minEdad: 13, maxEdad: Infinity, minPulso: 60, maxPulso: 110 },
        ];

        const rango = rangosEdad.find(r => this.edadPaciente >= r.minEdad && this.edadPaciente <= r.maxEdad);
        
        const mensaje = (newVal >= rango.minPulso && newVal <= rango.maxPulso)
          ? "Pulso dentro del rango"
          : "Pulso fuera del rango de normalidad";
        this.mensajes.pulso = !(newVal >= rango.minPulso && newVal <= rango.maxPulso) ? "Pulso" : null
        
      }
    },


    temperatura(newVal) {
      if (newVal) {

        const rangosTemperatura = [
          { minEdad: 0,  maxEdad: 0,        minTemp: 36.1, maxTemp: 37.7 },
          { minEdad: 1,  maxEdad: 2,        minTemp: 36.1, maxTemp: 37.2 },
          { minEdad: 3,  maxEdad: 8,        minTemp: 36.1, maxTemp: 37.0 },
          { minEdad: 9, maxEdad: Infinity,  minTemp: 36.0, maxTemp: 37.0 }
        ];

        const rango = rangosTemperatura.find(r => this.edadPaciente >= r.minEdad && this.edadPaciente <= r.maxEdad);

        const mensaje = (newVal >= rango.minTemp && newVal <= rango.maxTemp)
          ? "Temperatura dentro del rango"
          : "Temperatura fuera del rango de normalidad";
        
        this.mensajes.temperatura = !(newVal >= rango.minTemp && newVal <= rango.maxTemp) ? "Temperatura " : null
      }
    },



    imc(newVal) {
      let mensaje = ''
      if (newVal < 20 || newVal > 30) {
        mensaje = "IMC"
        this.mensajes.imc = mensaje
      }else{
        mensaje = "El IMC esta dentro del rango"
        this.mensajes.imc = null
      }
      
    },


    freqRespiratoria(newVal) {
      if (newVal) {


        const rangosEdad = [
          { minEdad: 0,  maxEdad: 0,         minFreq: 40, maxFreq: 70 },
          { minEdad: 1,  maxEdad: 3,         minFreq: 22, maxFreq: 30 },
          { minEdad: 4,  maxEdad: 6,         minFreq: 20, maxFreq: 24 },
          { minEdad: 7,  maxEdad: 12,        minFreq: 16, maxFreq: 22 },
          { minEdad: 13, maxEdad: Infinity,  minFreq: 12, maxFreq: 20 }
        ];

        const rango = rangosEdad.find(r => this.edadPaciente >= r.minEdad && this.edadPaciente <= r.maxEdad);

        const mensaje = (newVal >= rango.minFreq && newVal <= rango.maxFreq)
          ? "Frecuencia respiratoria dentro del rango"
          : "Frecuencia respiratoria ";
        this.mensajes.freqRespiratoria = !(newVal >= rango.minFreq && newVal <= rango.maxFreq) ? mensaje : null
      }
    },


    satOxigeno(newVal) {
      if (newVal) {
        const rangosSaturacion = {
          menorDe1: { min: 93, max: 100 },
          mayorDe1: { min: 93, max: 100 }
        };

        const { min, max } = this.edadPaciente < 1 
          ? rangosSaturacion.menorDe1 
          : rangosSaturacion.mayorDe1;

        const mensaje = (newVal >= min && newVal <= max)
          ? "Saturacion dentro del rango"
          : "Saturacion Oxigeno";

          this.mensajes.satOxigeno = !(newVal >= min && newVal <= max) ? mensaje : null
        //this.$toast[(newVal >= min && newVal <= max) ? 'success' : 'error'](mensaje);
      }
    },



    talla(newVal) {
      if(newVal) { 
        this.calcularIMC();
      }
    },
    peso(newVal) {
      if(newVal) { 
        this.calcularIMC();
      }
      
    },

    'tensionArterial.sistolica'(newVal){
      if(newVal) { 
        this.alertaTension(this.tensionArterial.sistolica, this.tensionArterial.diastolica, this.edadPaciente)
      }
    },

    'tensionArterial.diastolica'(newVal){
      if(newVal) { 
        this.alertaTension(this.tensionArterial.sistolica, this.tensionArterial.diastolica, this.edadPaciente)
      }
    },

    mensajes:{
      deep:true,
      immediate:true,
      handler(newValue){
        if(newValue){
          // console.log("cambio", newValue)
        }
     
      }
    },


    '$route.query.signosVitales': {
      deep: true,
      handler(newValue) {
        if(!newValue) return;
        this.loadDataCita();
      }
    }
  },

}
</script>
